// Copyright (c) 2020 Verimatrix, Inc.  All Rights Reserved.
import React, {Component} from 'react'
import moment from 'moment'

import './index.css'

export default class LastRefreshDate extends Component {
  renderLastRefeshDate (date) {
    let momentDate = moment(date)
    let formattedDate = momentDate.format('MMM Do, YYYY [at] h:mm:ss')
    let regex = /\s(...[-+])([0-9][0-9])/.exec(date.toString())
    if (regex) {
      let gmt = regex[1] + parseInt(regex[2])
      let fromNowDate = moment(date).fromNow()
      return (
        <div className='last-refresh-date'>
          <span>Data last refreshed on {`${formattedDate} ${gmt}`} <b>{fromNowDate}</b></span>
        </div>
      )
    }
  }


  render () {
    const {date} = this.props
    return (
      <>
        {date && this.renderLastRefeshDate(date)}
      </>
    )
  }
}


